import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

const Radio = ({
  checked,
  children,
  className = '',
  color = '',
  dataAttr,
  onChange,
  radioPackage = false,
  style = {}
}) => {
  return (
    <span
      style={style}
      className={`super-radio-container${className ? ' ' + className : ''}${checked ? ' checked' : ''}${
        color ? ' ' + color : ''
      }`}
      onClick={onChange}
      data-attr={dataAttr}
    >
      <label className='radio clearfix radio-label'>
        <span className='super-icon' />
        <span className='super-label' data-attr={radioPackage ? 'booking-membership-package' : null}>
          {children}
        </span>
      </label>
    </span>
  )
}

Radio.propTypes = {
  checked: PropTypes.bool.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  dataAttr: PropTypes.string,
  onChange: PropTypes.func,
  radioPackage: PropTypes.bool,
  style: PropTypes.object
}

export default Radio
